import { css, html } from 'lit';
import { view } from '../index.js';

export const [Button] = view('demo-button', {
  Props: class {
    label = '';
    onClick?: () => void = undefined;
  },

  template({ label, onClick }) {
    return html`
      <button class="btn" @click="${() => onClick?.()}">${label}</button>
    `;
  },

  mapBuilder: ButtonBuilder => (label: string) => ButtonBuilder().label(label),

  cssTemplate: css`
    .btn {
      background-color: #410e3e;
      color: #fff;
    }
  `,
});
